import parseJSON from './parse-json';

export function getURLParams($location) {
  const urlParams = new URLSearchParams($location.search);
  return Array.from(urlParams.keys()).reduce((prev, curr) => ({
    ...prev,
    [curr]: urlParams.get(curr),
  }), {});
}

export function getDOMParams($document) {
  // NOTE: this element is on legacy which could contain data that we want to
  // pass to the DRE 2.0 app
  const el = $document.querySelector('.returns-view-wrapper');
  const text = el?.getAttribute('data-order-details');
  const json = text?.replace(/&quot;/g, '"');
  const data = parseJSON(json, {});
  const { orderNumber, orderEmail, email } = data;
  const domParams = { };
  if (orderNumber) {
    domParams.orderNumber = orderNumber;
  }
  if (orderEmail && orderEmail !== 'false') {
    domParams.orderEmail = orderEmail;
  } else if (email && email !== 'false') {
    domParams.orderEmail = email;
  }
  return domParams;
}

// Centralized instance UID resolver for DOM-aware code paths
export function getInstanceUid($document, containerID, fallbackUid = 'dre20params') {
  if ($document && containerID) {
    const container = $document.getElementById(containerID);
    return container?.getAttribute('data-uid') || fallbackUid;
  }
  if ($document) {
    const dreContainer = $document.querySelector('[data-uid]');
    return dreContainer?.getAttribute('data-uid') || fallbackUid;
  }
  return fallbackUid;
}

export function hasMultipleInstances($document) {
  if (!$document) {
    return false;
  }
  
  const uidElements = $document.querySelectorAll('[data-uid]');
  return uidElements.length > 1;
}

/**
 * Discovers the current instance UID by looking at the DOM context
 * This function works independently for each instance
 * @returns {string} The UID for the current instance
 */
function discoverCurrentInstanceUid() {
  // Strategy 1: Look for the closest parent with data-uid attribute
  let element = document.activeElement || document.body;
  while (element && element !== document.documentElement) {
    if (element.hasAttribute('data-uid')) {
      return element.getAttribute('data-uid');
    }
    element = element.parentElement;
  }
  
  // Strategy 2: Look for the closest DRE container
  const dreContainer = document.querySelector('.dre-mfe-parent-wrapper[data-uid]');
  if (dreContainer) {
    return dreContainer.getAttribute('data-uid');
  }
  
  // Strategy 3: Fallback to default
  return 'dre20params';
}

export function getParams($window, uid) {
  if (typeof $window !== 'object' || $window === null) {
    return {};
  }
  
  // If no UID provided, discover it from the current DOM context
  const targetUid = uid || discoverCurrentInstanceUid();
  
  // Get params from the specified UID, fallback to default dre20params if not found
  const uidParams = $window[targetUid] || $window.dre20params || {};
  
  return {
    ...uidParams,
    ...getURLParams($window.location),
    ...getDOMParams($window.document),
  };
}